import initialPageData from '@/mock.json'

export default {
  token: '', // 用户令牌
  userInfo: null, // 用户信息
  isLogin: false, // 登录状态
  terminalType: 'phone', // 设备类型
  setting: null, // 全局设置数据
  loginTime: null, // 登录时间戳
  pageData: initialPageData,
  history: [],
  action: '',
  series: null
};
